import React, { useState } from 'react'
import { apiClient } from '@/utils/api'
import { ExternalLink, Loader2 } from 'lucide-react'

export const ManageSubscription: React.FC = () => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const openCustomerPortal = async () => {
    try {
      setLoading(true)
      setError(null)
      const { portal_url } = await apiClient.getCustomerPortal(
        window.location.origin + '/dashboard/settings'
      )
      window.location.href = portal_url
    } catch (err: any) {
      setError(err.response?.data?.detail || 'Failed to open customer portal')
      setLoading(false)
    }
  }

  return (
    <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-200">
      <h3 className="text-xl font-semibold text-gray-900 mb-4">Manage Subscription</h3>
      <p className="text-gray-600 mb-6">
        Update your payment method, change your plan, or cancel your subscription through our secure billing portal.
      </p>

      {error && (
        <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-lg">
          <p className="text-sm text-red-600">{error}</p>
        </div>
      )}

      <button
        onClick={openCustomerPortal}
        disabled={loading}
        className="inline-flex items-center gap-2 bg-blue-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-blue-700 transition disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {loading ? (
          <>
            <Loader2 className="h-5 w-5 animate-spin" />
            Opening Portal...
          </>
        ) : (
          <>
            <ExternalLink className="h-5 w-5" />
            Open Billing Portal
          </>
        )}
      </button>

      <div className="mt-6 p-4 bg-gray-50 rounded-lg">
        <h4 className="text-sm font-semibold text-gray-900 mb-2">What you can do in the billing portal:</h4>
        <ul className="text-sm text-gray-600 space-y-1 list-disc list-inside">
          <li>Update payment method</li>
          <li>Change subscription plan</li>
          <li>View billing history and invoices</li>
          <li>Cancel or reactivate subscription</li>
        </ul>
      </div>
    </div>
  )
}
